import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { OrderSummary } from '../../../../api/shop/types/orderTypes';
import { getImageUrl } from '../../../../utils/imageUrl';

interface OrderSummaryCardsProps {
  summary: OrderSummary;
  loading?: boolean;
}

const OrderSummaryCards: React.FC<OrderSummaryCardsProps> = ({
  summary,
  loading = false,
}) => {
  if (loading) {
    return (
      <Row className="mb-4" style={{ display: 'flex', flexWrap: 'nowrap' }}>
        {[1, 2, 3, 4, 5].map((i) => (
          <Col key={i} style={{ flex: '1 1 0', minWidth: 0, paddingLeft: i === 1 ? '0' : '12px', paddingRight: i === 5 ? '0' : '12px' }}>
            <Card className="p-3" style={{ border: 'none' }}>
              <div className="d-flex align-items-center">
                <div style={{ marginRight: '16px' }}>
                  <div className="placeholder" style={{ width: '40px', height: '40px', borderRadius: '4px' }}></div>
                </div>
                <div className="flex-grow-1">
                  <div className="placeholder mb-2" style={{ height: '24px', width: '40px', borderRadius: '4px' }}></div>
                  <div className="placeholder" style={{ height: '16px', width: '100px', borderRadius: '4px' }}></div>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    );
  }

  const cards = [
    {
      label: 'Confirmed',
      count: summary.confirmed,
      bgColor: '#E3F2FD',
      textColor: '#1976D2',
      iconPath: 'admin/static-assets/icons/general/product.svg',
    },
    {
      label: 'Ready for Pickup',
      count: summary.readyForPickup,
      bgColor: '#F3E5F5',
      textColor: '#7B1FA2',
      iconPath: 'admin/static-assets/icons/general/product-pickup.svg',
    },
    {
      label: 'Delivered',
      count: summary.delivered,
      bgColor: '#E8F5E9',
      textColor: '#388E3C',
      iconPath: 'admin/static-assets/icons/general/product-active.svg',
    },
    {
      label: 'Return',
      count: summary.returned,
      bgColor: '#FFF3E0',
      textColor: '#F57C00',
      iconPath: 'admin/static-assets/icons/general/product-return.svg',
    },
    {
      label: 'Replacement',
      count: summary.replacement,
      bgColor: '#FFFDE7',
      textColor: '#FBC02D',
      iconPath: 'admin/static-assets/icons/general/product-replacment.svg',
    },
  ];

  return (
    <Row className="mb-4" style={{ display: 'flex', flexWrap: 'nowrap' }}>
      {cards.map((card, index) => (
        <Col key={index} style={{ flex: '1 1 0', minWidth: 0, paddingLeft: index === 0 ? '0' : '12px', paddingRight: index === cards.length - 1 ? '0' : '12px' }}>
          <Card className="p-3" style={{ backgroundColor: card.bgColor, border: 'none' }}>
            <div className="d-flex align-items-center">
              <div style={{ marginRight: '16px' }}>
                <img 
                  src={getImageUrl(card.iconPath)} 
                  alt={card.label} 
                  style={{ width: '40px', height: '40px' }}
                />
              </div>
              <div className="flex-grow-1">
                <h3 className="mb-0" style={{ fontSize: '24px', fontWeight: 700, color: card.textColor }}>
                  {card.count}
                </h3>
                <p className="mb-0" style={{ fontSize: '14px', color: card.textColor, fontWeight: 500 }}>
                  {card.label}
                </p>
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default OrderSummaryCards;
